import * as React from 'react';
import classnames from 'classnames';
import OPDialog from 'src/view/op-dialog';
export default function Image(props) {
    const { value = '' } = props;
    const [imgUrl, setImgUrl] = React.useState('');
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classnames('op-table-image'), onClick: (e) => {
                e.stopPropagation();
                setImgUrl(value);
            } },
            React.createElement("img", { alt: '', src: value })),
        imgUrl ? (React.createElement(OPDialog, { className: 'op-image-dialog', title: '\u56FE\u7247', visible: true, onOk: () => {
                setImgUrl('');
            }, footerActions: ['ok'] },
            React.createElement("div", { className: 'item-image' },
                React.createElement("img", { alt: '', src: imgUrl })))) : null));
}
